<template>
  <div>
    <header>
      <fire-image :refName="'header.jpg'"/>
      <h1>DÓMSDAGUR</h1>
    </header>

    <h3 class="content__desc"><a href="https://domsdagur.podbean.com/" target="_blank">Hlusta á þættina</a></h3>
    <div id="content">
      <div class="content__best-of">
        <best-of :last_three_episodeNrs="last_three_episodeNrs"></best-of>
      </div>
      <div class="content__episodes">
        <h2>Stjörnugjöf</h2>
        <p>Veldu þátt</p>
        <div class="content__episodes_holder">
          <router-link class="content__episodes__numbers" v-for="nr in episode_nrs" :to="`/episode/${nr}`" :key="nr">
            {{ nr }}
          </router-link>
        </div>
      </div>
      <div class="content__best-of">
        <best-of :count="5"></best-of>
      </div>
    </div>
  </div>
</template>

<script>
import {db} from '../main';
import BestOf from './BestOf.vue';
import FireImage from './FireImage.vue';

export default {
  components: {
    FireImage,
    BestOf
  },
  name: 'Index',
  data() {
    return {
      episodes: [],
    }
  },
  firestore() {
    return {
      episodes: db.collection('topics').orderBy('episode_nr')
    }
  },
  computed: {
    episode_nrs: function () {
      return Array.from(new Set(this.episodes.map(t => t.episode_nr)));
    },
    last_three_episodeNrs: function () {
      return Array.from(new Set(this.episode_nrs.sort((a, b) => a - b).reverse().slice(0, 3).reverse()));
    }
  }
}
</script>
<style scoped>

h1 {
  margin: 0;
}

header img {
  width: 100%;
}

#content {
  display: -webkit-flex; /* Safari */
  display: flex;
}

.content__episodes_holder {
  display: -webkit-flex; /* Safari */
  display: flex;
  flex-flow: row-reverse;
  -webkit-flex-flow: row;
  flex-wrap: wrap-reverse;
  -webkit-flex-wrap: wrap;
}

.content__episodes,
.content__best-of {
  width: 30%;
  border: 1px solid white;
  margin: 20px 2% 0 2%;
  border-radius: 5px;
  padding: 0 8px 16px 8px;
}

.content__episodes_holder a {
  border: 1px solid white;
  margin: 10px 5%;
  padding: 3px 1%;
  width: 20%;
  height: 35px;
  border-radius: 15px;
  color: #a79551;
  line-height: 225%;
}

.content__episodes_holder a:hover {
  background-color: #7b6c3d;
  color: #ffffff;
}

.content__best-of a {
  margin-top: 30px;
  display: block;
}

.content__desc {
  margin: 0px;
  text-align: center;
  width: 100%;
}

.content__desc a {
  color: gold;

}

@media screen and (max-width: 780px) {
  #content {
    -webkit-flex-wrap: wrap; /* Safari 6.1+ */
    flex-wrap: wrap;
  }

  .content__episodes {
    order: 3;
  }

  .content__episodes,
  .content__best-of {
    width: 100%;
  }

  .content__episodes_holder a {
    border: 1px solid white;
    margin: 3px 5%;
    padding: 3px 1%;
    width: 20%;
    height: 35px;
    border-radius: 15px;
    color: #a79551;
  }

  .content__episodes a {
    margin-top: 20px;
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Index.vue